'use client';
import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import {usePathname, useRouter, useSearchParams} from "next/navigation";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import BannerGallery from "@/components/project/BannerGallery";
import Glance from "@/components/project/Glance";
import FeatureSlider from "@/components/home/FeatureSlider";
import GetInTouch from "@/components/contact/ContactForm";


const MyComponent = ({initialData}) => {
    const [isClient, setIsClient] = useState(false);
    const pathname = usePathname(); // Get the current pathname as a string





    useEffect(() => {
        ScrollTrigger.refresh();
        // Scroll to top when page changes
        window.scrollTo(0, 1);
    }, [pathname]);



    return (
        <>
            <BannerGallery data={initialData?.page_data?.[0]}/>
            <Glance data={initialData?.page_data?.[0]?.at_a_glance}/>
            {
                initialData?.projects?.length > 0 &&
                <FeatureSlider isDetails data={initialData?.projects}/>

            }
            <GetInTouch iframe={initialData?.page_data?.[0]?.map?.iframe} project_name={initialData?.page_data?.[0]?.post_title} form_id={'156'} form_tag={'5b91540'}
                        link={initialData?.page_data?.[0]?.map?.url}
                        img={initialData?.page_data?.[0]?.map?.image}
                        title={initialData?.page_data?.[0]?.form?.title}
            />
        </>
    );
};
const StyledComponent = styled.section`
  

`
export default MyComponent;